__turbopack_context__.v({
  "body_rich_text": "ThreeColumn-module-scss-module__qt79NW__body_rich_text",
  "direction__column": "ThreeColumn-module-scss-module__qt79NW__direction__column",
  "direction__row": "ThreeColumn-module-scss-module__qt79NW__direction__row",
  "gradient-glow-blue": "ThreeColumn-module-scss-module__qt79NW__gradient-glow-blue",
  "gradient-glow-neon": "ThreeColumn-module-scss-module__qt79NW__gradient-glow-neon",
  "gradient-glow-orange": "ThreeColumn-module-scss-module__qt79NW__gradient-glow-orange",
  "gradient-glow-pink": "ThreeColumn-module-scss-module__qt79NW__gradient-glow-pink",
  "gradient-glow-snap-pea": "ThreeColumn-module-scss-module__qt79NW__gradient-glow-snap-pea",
  "gradient-neon-pink": "ThreeColumn-module-scss-module__qt79NW__gradient-neon-pink",
  "gradient-pink-blue": "ThreeColumn-module-scss-module__qt79NW__gradient-pink-blue",
  "gradient-pink-orange": "ThreeColumn-module-scss-module__qt79NW__gradient-pink-orange",
  "layout__content-leading": "ThreeColumn-module-scss-module__qt79NW__layout__content-leading",
  "layout__content-trailing": "ThreeColumn-module-scss-module__qt79NW__layout__content-trailing",
  "module-base": "ThreeColumn-module-scss-module__qt79NW__module-base",
  "module-content-swap": "ThreeColumn-module-scss-module__qt79NW__module-content-swap",
  "module_block__contained": "ThreeColumn-module-scss-module__qt79NW__module_block__contained",
  "module_block__uncontained": "ThreeColumn-module-scss-module__qt79NW__module_block__uncontained",
  "module_breadcrumbs": "ThreeColumn-module-scss-module__qt79NW__module_breadcrumbs",
  "section_bg_fill__base": "ThreeColumn-module-scss-module__qt79NW__section_bg_fill__base",
  "section_bg_fill__gradient": "ThreeColumn-module-scss-module__qt79NW__section_bg_fill__gradient",
  "section_bg_fill__no-fill": "ThreeColumn-module-scss-module__qt79NW__section_bg_fill__no-fill",
  "section_bg_fill__raised": "ThreeColumn-module-scss-module__qt79NW__section_bg_fill__raised",
  "section_container": "ThreeColumn-module-scss-module__qt79NW__section_container",
  "with_breadcrumb": "ThreeColumn-module-scss-module__qt79NW__with_breadcrumb",
  "with_navbar": "ThreeColumn-module-scss-module__qt79NW__with_navbar",
});
